export const linkTypes = {
  tag: "TAG",
  ticket: "TICKET",
  no_reference: "NO_REFERENCE",
};
export class SignUpCredentials {
  email = null;
  link = {
    type: null,
    data: null,
  };

  constructor(email, linkType, linkData) {
    this.email = email;
    this.link.type = linkType;
    this.link.data = linkData;
  }

  toJSON() {
    return {
      email: this.email,
      link: {
        type: this.link.type,
        data: this.link.data,
      },
      locale:
        (navigator.language || navigator.userLanguage).split("-")[0] === "es"
          ? "es"
          : (navigator.language || navigator.userLanguage).split("-")[0] ===
            "sv"
          ? "sv"
          : (navigator.language || navigator.userLanguage).split("-")[0] ===
            "pt"
          ? "pt"
          : "en",
    };
  }
}
